// @ts-strict-ignore
import {Component, Injector, OnInit} from "@angular/core";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";
import {Translations} from "@translations";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {SimIconsetService, SimMaterialDialogService, NotificationService} from "@services";
import {Icon, Iconset} from "@models";
import {TranslateService} from "@ngx-translate/core";
import {DialogData_DeleteDialogOutput} from "../delete-dialog-mat/delete-dialog-mat.component";

export interface DialogData_CreateBookmarkDialogInput extends MatDialogDataBaseInput {
	bookmarkSetId: string;
	editBookmarkIcon?: Icon;
}

export interface DialogData_CreateBookmarkDialogOutput extends MatDialogDataBaseOutput {
	bookmark?: Icon;
}

@Component({
	selector: "sim-add-marker-dialog",
	templateUrl: "./create-bookmark-dialog.component.html",
	styleUrls: ["./create-bookmark-dialog.component.scss"],
	standalone: false,
})
export class CreateBookmarkDialogComponent
	extends BasicMaterialDialog<CreateBookmarkDialogComponent, DialogData_CreateBookmarkDialogInput, DialogData_CreateBookmarkDialogOutput>
	implements OnInit
{
	// Properties
	public inputGroup = new FormGroup({
		abbreviation: new FormControl<string>(null, Validators.required),
		tooltip: new FormControl<string>(null),
	});
	public ABBREVIATION_MAX_CHARS: number = 16;
	public bookmarkIcon: Icon = {} as Icon;
	protected readonly Translations = Translations;

	constructor(
		_injector: Injector,
		private _simIconSetService: SimIconsetService,
		private _simNotificationService: NotificationService,
		private _simDialogService: SimMaterialDialogService,
		private translate: TranslateService,
	) {
		super(_injector);
	}

	ngOnInit(): void {
		if (!!this.data.editBookmarkIcon) {
			this.bookmarkIcon = this.data.editBookmarkIcon;
			this.inputGroup.controls.abbreviation.setValue(this.bookmarkIcon.abbreviation);
			this.inputGroup.controls.tooltip.setValue(this.bookmarkIcon.tooltip);
		}
	}

	public doDelete(): void {
		this._simDialogService
			.openDeleteDialog({
				deleteTitle: this.translate.instant(Translations.BOOKMARK_DELETE_DIALOG_TITLE),
				deleteText: this.translate.instant(Translations.BOOKMARK_DELETE_DIALOG_TEXT, {
					bookmarkName: this.bookmarkIcon.abbreviation,
				}),
				deleteButtonText: this.translate.instant(Translations.BUTTON_DELETE),
				cancelText: this.translate.instant(Translations.BUTTON_CANCEL),
			})
			.then((data: DialogData_DeleteDialogOutput) => {
				if (data.action === "ok") return this._simIconSetService.deleteTextMarker(this.bookmarkIcon);
			})
			.then(this.doClose());
	}

	public doSave(): void {
		// Validate & init input
		if (!this.inputGroup.valid) return;
		this.bookmarkIcon.abbreviation = this.inputGroup.controls.abbreviation.value.toUpperCase();
		this.bookmarkIcon.tooltip = this.inputGroup.controls.tooltip.value;

		// Persist
		const inputMarkerSet: Iconset = {icons: [this.bookmarkIcon]} as Iconset;
		this._simIconSetService.upsertTextMarkerIconset(inputMarkerSet).then(this.doClose());
	}

	private doClose() {
		return (res: boolean) => {
			if (res) {
				this.close({action: "ok"});
			} else {
				this._simNotificationService.notifyError(this.translate.instant(this.T.EVENT_CREATION_SEND_MAIL_FAILURE));
			}
		};
	}

	getValueFromAbbreviation() {
		return this.inputGroup.controls.abbreviation.value;
	}
}
